<template>
  <div class="not-find">
    <div style="margin-top: -60px; text-align: center;">
      <img src="./img/404.png" />
      <div style="color: #a5afb5; font-size: 17px;">抱歉，你访问的页面不存在</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "app-error-404"
  }
</script>

<style scoped>
  .not-find {
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
